import {
    SortVertical,
    DollarMinimalistic,
    TagHorizontal,
    ClockCircle,
    Cart2,
    UsersGroupRounded,
    TagPrice,
    BillList,
    AlarmAdd,
    GraphNewUp,
    NotesMinimalistic,
    Running,
} from "@solar-icons/react/ssr";
import { LINE_RUNNING_COLUMN_ID_PREFIX } from "./constants";
import { store } from "./bidStore";

const MAKERS_SUBSCRIPTION = 1;

const getClientCurrencyFormatter = (projectCurreny) => {
    return new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: projectCurreny || "CAD",
        maximumFractionDigits: 0,
    });
};

const getPercentageFormatter = () => {
    return new Intl.NumberFormat("en-CA", {
        style: "percent",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    });
};

export const leftStickingColumnProfiles = [
    {
        id: "_order",
        type: "text",
        width: 10,
        defaultWidth: 10,
        renderer: () => <span style={{ cursor: "pointer" }}> ≡ </span>,
        alwaysVisible: true,
        nonEditable: true,
        leftSticking: true,
    },
    // {
    //     id: "id",
    //     headerIcon: <SortVertical size={14} />,
    //     headerText: "Internal ID",
    //     defaultWidth: 120,
    //     width: 120,
    //     type: "customText",
    //     leftSticking: true,
    //     nonEditable: true,
    // },
    // {
    //     id: "sort_order",
    //     headerIcon: <SortVertical size={14} />,
    //     headerText: "Order",
    //     defaultWidth: 120,
    //     width: 50,
    //     type: "customNumber",
    //     leftSticking: true,
    //     nonEditable: true,
    //     alwaysVisible: true
    // },
    {
        id: "custom_id",
        headerIcon: <SortVertical size={14} />,
        headerText: "ID",
        defaultWidth: 60,
        width: 60,
        type: "customText",
        leftSticking: true,
    },
    {
        id: "name",
        headerIcon: <SortVertical size={14} />,
        headerText: "Name",
        type: "customChevron",
        defaultWidth: 300,
        width: 300,
        alwaysVisible: true,
        leftSticking: true,
    },
];

export const columnProfilesMiddle = [
    {
        id: "is_internal",
        headerIcon: <DollarMinimalistic size={14} />,
        headerText: "Resource Type",
        type: "customDropdownResourceType",
        visible: [MAKERS_SUBSCRIPTION],
    },
    {
        id: "internal_rate",
        headerIcon: <TagHorizontal size={14} />,
        headerText: "Internal Rate",
        type: "simpleFormula",
        restricted: true,
        hasRunning: false,
    },
    {
        id: "internal_markup",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Internal Markup %",
        type: "simpleFormulaPercentage",
        restricted: true,
        formatter: getPercentageFormatter,
        hasRunning: false,
    },
    {
        id: "vendor_currency",
        headerIcon: <DollarMinimalistic size={14} />,
        headerText: "Currency",
        type: "customDropdownCurrency",
        visible: true,
    },
    {
        id: "vendor_rate",
        headerIcon: <TagHorizontal size={14} />,
        headerText: "Rate",
        type: "dynamicRate",
        visible: true,
    },
    {
        id: "rate_type",
        headerIcon: <ClockCircle size={14} />,
        headerText: "Rate Type",
        type: "customDropdownRateType",
        visible: true,
    },
    {
        id: "vendor_client_exchange_rate_saved",
        headerIcon: <DollarMinimalistic size={14} />,
        headerText: "FX",
        type: "customNumber",
        visible: false,
        runningVisible: false,
        nonEditable: true,
    },
    {
        id: "exchange_rate_buffer",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "FX Buffer",
        type: "simpleFormula",
        visible: false,
        runningVisible: false,
        nonEditable: true,
    },
    {
        id: "client_rate",
        headerIcon: <TagHorizontal size={14} />,
        headerText: "Cost",
        type: "customNumber",
        visible: true,
        nonEditable: true,
        formatter: getClientCurrencyFormatter,
    },
    {
        id: "budget_buffer",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Budget Buffer %",
        type: "simpleFormulaPercentage",
        visible: true,
    },
    {
        id: "budget_buffer_amount",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Budget Buffer $",
        type: "simpleFormula",
        visible: true,
        runningVisible: false,
    },
    {
        id: "client_rate_budget_buffered",
        headerIcon: <TagHorizontal size={14} />,
        headerText: "Budgeted Rate",
        type: "customNumber",
        visible: true,
        runningVisible: false,
        nonEditable: true,
        formatter: getClientCurrencyFormatter,
    },
    {
        id: "markup",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Markup %",
        type: "simpleFormulaPercentage",
        visible: true,
        formatter: getClientCurrencyFormatter,
        hasRunning: false,
    },
    {
        id: "markup_amount",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Markup $",
        type: "simpleFormula",
        visible: true,
        hasRunning: false,
    },
    {
        id: "client_rate_quoted",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Quoted Rate",
        type: "customNumber",
        visible: true,
        nonEditable: true,
        formatter: getClientCurrencyFormatter,
        hasRunning: false,
    },
    {
        id: "days",
        headerIcon: <UsersGroupRounded size={14} />,
        headerText: "Units",
        type: "simpleFormulaOneAsEmpty",
        visible: true,
    },
    {
        id: "quantity",
        headerIcon: <Cart2 size={14} />,
        headerText: "Qty",
        type: "simpleFormula",
        visible: true,
    },
    {
        id: "ot_1_5",
        headerIcon: <AlarmAdd size={14} />,
        headerText: "OT 1.5",
        type: "simpleFormula",
        visible: [MAKERS_SUBSCRIPTION],
    },
    {
        id: "ot_2_0",
        headerIcon: <AlarmAdd size={14} />,
        headerText: "OT 2.0",
        type: "simpleFormula",
        visible: [MAKERS_SUBSCRIPTION],
    },
    {
        id: "adjustment",
        headerIcon: <GraphNewUp size={14} />,
        headerText: "Adjustment",
        type: "simpleFormula",
        visible: true,
        hasRunning: false,
    },
    {
        id: "external_notes",
        headerIcon: <NotesMinimalistic size={14} />,
        headerText: "External Notes",
        type: "customText",
        defaultWidth: 300,
        width: 300,
        visible: true,
        hasRunning: false,
    },
    {
        id: "internal_notes",
        headerIcon: <NotesMinimalistic size={14} />,
        headerText: "Internal Notes",
        type: "customText",
        defaultWidth: 300,
        width: 300,
        visible: true,
        hasRunning: false,
    },
    {
        id: "internal_budget",
        headerIcon: <TagPrice size={14} />,
        headerText: "Internal Cost",
        type: "customNumber",
        nonEditable: true,
        restricted: true,
        formatter: getClientCurrencyFormatter,
        hasRunning: false,
    },
];

export let columnProfilesBase =
    leftStickingColumnProfiles.concat(columnProfilesMiddle);

let columnProfilesRunning = [];
columnProfilesBase.forEach((col) => {
    if (col.hasRunning != false) {
        let runningCol = {
            ...col,
            isRunning: true,
            id: `${LINE_RUNNING_COLUMN_ID_PREFIX}.${col.id}`,
        };
        if (col.runningVisible == false) {
            runningCol.visible = false;
        }
        columnProfilesRunning.push(runningCol);
    }
});

export const rightStickingColumnProfiles = [
    {
        id: "client_budget_buffered",
        headerIcon: <BillList size={14} />,
        headerText: "Budget Total",
        type: "customNumber",
        nonEditable: true,
        sticky: true,
        visible: true,
        formatter: getClientCurrencyFormatter,
    },
    {
        id: "client_quoted",
        headerIcon: <BillList size={14} />,
        headerText: "Quoted Total",
        type: "customNumber",
        nonEditable: true,
        sticky: true,
        alwaysVisible: true,
        formatter: getClientCurrencyFormatter,
    },
];

export const rightStickingColumnProfilesRunning = [
    {
        id: `${LINE_RUNNING_COLUMN_ID_PREFIX}.client_budget_buffered`,
        headerIcon: <Running size={14} />,
        headerText: "Running Budget",
        type: "customNumber",
        nonEditable: true,
        sticky: true,
        visible: true,
        formatter: getClientCurrencyFormatter,
        isRunning: true,
    },
    {
        id: `${LINE_RUNNING_COLUMN_ID_PREFIX}.variance`,
        headerIcon: <Running size={14} />,
        headerText: "Variance",
        type: "customNumber",
        nonEditable: true,
        sticky: true,
        visible: true,
        formatter: getClientCurrencyFormatter,
        isRunning: true,
    },
    {
        id: `${LINE_RUNNING_COLUMN_ID_PREFIX}.client_budget_buffered_original`,
        headerIcon: <BillList size={14} />,
        headerText: "Budget Total",
        type: "customNumber",
        nonEditable: true,
        sticky: true,
        visible: true,
        formatter: getClientCurrencyFormatter,
        isRunning: true,
    },
    {
        id: `${LINE_RUNNING_COLUMN_ID_PREFIX}.client_quoted_original`,
        headerIcon: <BillList size={14} />,
        headerText: "Quoted Total",
        type: "customNumber",
        nonEditable: true,
        sticky: true,
        visible: true,
        formatter: getClientCurrencyFormatter,
        isRunning: true,
        alwaysVisible: true,
    },
];

export let allColumnProfiles = leftStickingColumnProfiles
    .concat(columnProfilesBase)
    .concat(columnProfilesRunning)
    .concat(rightStickingColumnProfiles)
    .concat(rightStickingColumnProfilesRunning);

export const updateDynamicColumnsFromBid = (bid) => {
    // 1. Rebuild base without any dynamic columns
    columnProfilesBase =
        leftStickingColumnProfiles.concat(columnProfilesMiddle);

    // 2. Insert dynamic sub_quantity columns before "quantity"
    const subQuantityCols = (bid?.sub_quantity_columns || []).map((col) => ({
        id: `sub_quantities.${col.id}`,
        headerIcon: <Cart2 size={14} />,
        headerText: col.name,
        type: "simpleFormula",
        visible: true,
        hasRunning: true,
    }));

    const qtyIndex = columnProfilesBase.findIndex(
        (col) => col.id === "quantity",
    );
    if (qtyIndex !== -1) {
        // Rename and make readonly when custom sub-quantity columns exist
        columnProfilesBase[qtyIndex] = {
            ...columnProfilesBase[qtyIndex],
            headerText: subQuantityCols.length > 0 ? "Total Qty" : "Qty",
            nonEditable: subQuantityCols.length > 0,
        };
    }

    if (subQuantityCols.length > 0) {
        // Re-find after potential replacement
        const updatedQtyIndex = columnProfilesBase.findIndex(
            (col) => col.id === "quantity",
        );
        if (updatedQtyIndex !== -1) {
            columnProfilesBase.splice(updatedQtyIndex, 0, ...subQuantityCols);
        } else {
            columnProfilesBase.push(...subQuantityCols);
        }
    }

    // 3. Rebuild running columns
    columnProfilesRunning = [];
    columnProfilesBase.forEach((col) => {
        if (col.hasRunning != false) {
            let runningCol = {
                ...col,
                isRunning: true,
                id: `${LINE_RUNNING_COLUMN_ID_PREFIX}.${col.id}`,
            };
            if (col.runningVisible == false) {
                runningCol.visible = false;
            }
            columnProfilesRunning.push(runningCol);
        }
    });

    // 4. Rebuild allColumnProfiles
    allColumnProfiles = leftStickingColumnProfiles
        .concat(columnProfilesBase)
        .concat(columnProfilesRunning)
        .concat(rightStickingColumnProfiles)
        .concat(rightStickingColumnProfilesRunning);
};

export const getColumnProfiles = () => {
    const isRunning = store.showRunning;
    if (isRunning) {
        return columnProfilesRunning.concat(rightStickingColumnProfilesRunning);
    } else {
        return columnProfilesBase.concat(rightStickingColumnProfiles);
    }
};

export const getOriginalBidColumns = () => {
    return columnProfilesBase.concat(rightStickingColumnProfiles);
};

export const getLeftStickingColumnCount = () => {
    const isRunning = store.showRunning;
    if (isRunning) {
        return columnProfilesRunning.filter(
            (col) => (col.visible || col.alwaysVisible) && col.leftSticking,
        ).length;
    } else {
        return columnProfilesBase.filter(
            (col) => (col.visible || col.alwaysVisible) && col.leftSticking,
        ).length;
    }
};

export const visibleRunningColumns = () => {
    return columnProfilesRunning
        .concat(rightStickingColumnProfilesRunning)
        .filter((col) => col.id != `${LINE_RUNNING_COLUMN_ID_PREFIX}.custom_id`)
        .map((col) => col.id);
};

export const stickyRunningColumns = () => {
    return rightStickingColumnProfilesRunning.map((col) => col.id);
};
